export default "__VITE_ASSET__d889524e__"